export default "__VITE_ASSET__641fe315__"